module.exports = __webpack_public_path__ + "media/images/yes-circle-4e755a56f2d392b1b63fbc846e1ca0a1.png";